'use client';

import Link from 'next/link';
import Image from 'next/image';
import { useAuthRedirect } from '@/hooks/useAuthRedirect';
import { useRouter } from 'next/navigation';
import { siteConfig } from '@/config/site';
import LoadingSpinner from '@/components/ui/loading';
export default function HomePage() {
  const { user, isLoading } = useAuthRedirect();
  const router = useRouter();

  if (isLoading) {
    return <LoadingSpinner />;
  }

  if (!user) {
    router.push('/login');
  }

  return (
    <main className="flex flex-1 flex-col items-center justify-center text-center max-w-7xl mx-auto px-4 py-16 ">
      <div className="space-y-12">
        <div className="space-y-6">
          <h1 className="text-5xl font-bold tracking-tight sm:text-7xl bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-purple-500 dark:from-blue-400 dark:to-purple-400">
            Welcome to {siteConfig.name} Docs
          </h1>
          <p className="text-2xl text-gray-600 dark:text-gray-300">
            Your comprehensive guide to building scalable applications with {siteConfig.name}
          </p>
          <div className="flex gap-6 justify-center">
            <Link
              href="/docs"
              className="inline-flex items-center px-6 py-3 rounded-lg bg-blue-600 text-white font-medium hover:bg-blue-700 transition-colors dark:bg-blue-500 dark:hover:bg-blue-600"
            >
              Get Started →
            </Link>
            <Link
              href="/docs"
              className="inline-flex items-center px-6 py-3 rounded-lg border border-gray-300 dark:border-gray-600 hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors"
            >
              View Documentation
            </Link>
          </div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 text-left">
          <div className="p-6 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
            <h3 className="text-xl font-semibold mb-2">Easy Integration</h3>
            <p className="text-gray-600 dark:text-gray-300">Seamlessly integrate {siteConfig.name} into your existing applications</p>
          </div>
          <div className="p-6 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
            <h3 className="text-xl font-semibold mb-2">Powerful Features</h3>
            <p className="text-gray-600 dark:text-gray-300">Built-in support for modern development workflows</p>
          </div>
          <div className="p-6 rounded-xl border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800">
            <h3 className="text-xl font-semibold mb-2">Great Documentation</h3>
            <p className="text-gray-600 dark:text-gray-300">Comprehensive guides and API documentation</p>
          </div>
        </div>
      </div>
    </main>
  );
}
